import React, { Component } from 'react'

export default class FAQ extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'getting-started',
      openQuestion: 0
    }
  }

  toggleQuestion = (index) => {
    this.setState({
      openQuestion: this.state.openQuestion === index ? -1 : index
    })
  }

  render() {
    const { activeTab, openQuestion } = this.state

    const faqData = {
      'getting-started': {
        title: 'Getting Started',
        questions: [
          {
            question: 'How can I start using your platform?',
            answer: 'To get started, visit our website and click the "Get Started" button. Follow the easy steps to share your information, and our team will review your application.'
          },
          {
            question: 'Is joining your platform paid?',
            answer: 'No, it is completely free! There are no registration fees or hidden costs. Joining does not cost you anything.'
          },
          {
            question: 'What benefits do I get when I join your platform?',
            answer: 'When you register, you reach a wider market and access more earning opportunities. You can reach more customers and expand your service range.'
          },
          {
            question: 'Can you explain the getting started process step by step?',
            answer: 'Of course. After you provide your information, our team will quickly review your application. Once approved, you will have access to the platform. The process is simple and user-friendly.'
          },
          {
            question: 'Can you give general information about how your platform works?',
            answer: 'Our platform works like a technologically advanced hub. It connects partners with many tours, activities, and services. You can easily promote and sell these to a wide audience. This collaboration creates new business opportunities for all parties.'
          }
        ]
      },
      'product-service': {
        title: 'Product & Service',
        questions: [
          {
            question: 'What products and services do you offer?',
            answer: 'We offer a wide range of travel products including tours, activities, accommodation, and transfer services.'
          },
          {
            question: 'How can I list my products?',
            answer: 'Log in to your account and you can easily add new products and edit your existing products from the product management section.'
          },
          {
            question: 'Can I set the pricing myself?',
            answer: 'Yes, you have complete control over pricing. You can make price updates anytime you want.'
          }
        ]
      },
      'booking-management': {
        title: 'Booking Management',
        questions: [
          {
            question: 'How can I manage reservations?',
            answer: 'You can track, confirm, or cancel all your reservations from a single panel.'
          },
          {
            question: 'Can I receive instant booking notifications?',
            answer: 'Yes, you receive instant notifications for every new reservation. Email and SMS notifications can be activated.'
          },
          {
            question: 'How do I set cancellation policies?',
            answer: 'You can create your own cancellation policies and customize them for each product.'
          }
        ]
      },
      'technical-support': {
        title: 'Technical Support',
        questions: [
          {
            question: 'What should I do if I experience technical problems?',
            answer: 'Our support team is at your service 24/7. You can reach us via live chat, email, or phone.'
          },
          {
            question: 'Is platform training provided?',
            answer: 'Yes, we provide free platform training and user guides to all our new members.'
          },
          {
            question: 'Is there a mobile app?',
            answer: 'Yes, our mobile app is available for iOS and Android. You can manage your business from anywhere.'
          }
        ]
      }
    }

    return (
      <div style={{
        padding: '60px 5%',
        backgroundColor: '#fff'
      }}>
        {/* Section Header */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '40px'
        }}>
          <div style={{
            display: 'inline-block',
            backgroundColor: 'rgba(77, 184, 205, 0.1)',
            color: '#4db8cd',
            fontSize: '10px',
            fontWeight: '700',
            letterSpacing: '2px',
            padding: '6px 16px',
            borderRadius: '20px',
            marginBottom: '15px',
            textTransform: 'uppercase'
          }}>
            Frequently Asked Questions
          </div>
          <h2 style={{
            fontSize: '32px',
            fontWeight: '700',
            margin: '0',
            color: '#1a2332',
            lineHeight: '1.3'
          }}>
            Have Questions? We Have Answers!
          </h2>
        </div>

        {/* Tabs */}
        <div style={{
          maxWidth: '1000px',
          margin: '0 auto',
          marginBottom: '30px'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            flexWrap: 'wrap',
            marginBottom: '30px'
          }}>
            {Object.keys(faqData).map((key) => (
              <button
                key={key}
                onClick={() => this.setState({ activeTab: key, openQuestion: 0 })}
                style={{
                  padding: '10px 24px',
                  borderRadius: '25px',
                  border: activeTab === key ? '2px solid #4db8cd' : '2px solid #e0f7fa',
                  backgroundColor: activeTab === key ? '#4db8cd' : '#fff',
                  color: activeTab === key ? '#fff' : '#5c636c',
                  fontSize: '13px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  outline: 'none'
                }}
                onMouseEnter={(e) => {
                  if (activeTab !== key) {
                    e.target.style.borderColor = '#4db8cd';
                    e.target.style.color = '#4db8cd';
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeTab !== key) {
                    e.target.style.borderColor = '#e0f7fa';
                    e.target.style.color = '#5c636c';
                  }
                }}
              >
                {faqData[key].title}
              </button>
            ))}
          </div>

          {/* FAQ Content */}
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '12px',
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.06)',
            overflow: 'hidden'
          }}>
            {faqData[activeTab].questions.map((item, index) => (
              <div
                key={index}
                style={{
                  borderBottom: index !== faqData[activeTab].questions.length - 1 ? '1px solid #f0f4f7' : 'none'
                }}
              >
                {/* Question */}
                <div
                  onClick={() => this.toggleQuestion(index)}
                  style={{
                    padding: '20px 28px',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: openQuestion === index ? 'rgba(77, 184, 205, 0.03)' : '#fff',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    if (openQuestion !== index) {
                      e.currentTarget.style.backgroundColor = '#f8f9fa';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (openQuestion !== index) {
                      e.currentTarget.style.backgroundColor = '#fff';
                    }
                  }}
                >
                  <h5 style={{
                    fontSize: '14px',
                    fontWeight: openQuestion === index ? '600' : '500',
                    color: openQuestion === index ? '#4db8cd' : '#2c3e50',
                    margin: '0',
                    flex: 1,
                    transition: 'all 0.3s ease'
                  }}>
                    {item.question}
                  </h5>
                  <div style={{
                    width: '28px',
                    height: '28px',
                    borderRadius: '50%',
                    backgroundColor: openQuestion === index ? '#4db8cd' : 'rgba(77, 184, 205, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease',
                    marginLeft: '15px'
                  }}>
                    <i 
                      className={`bi bi-${openQuestion === index ? 'dash' : 'plus'}`}
                      style={{
                        fontSize: '14px',
                        color: openQuestion === index ? '#fff' : '#4db8cd',
                        fontWeight: 'bold'
                      }}
                    ></i>
                  </div>
                </div>

                {/* Answer */}
                <div
                  style={{
                    maxHeight: openQuestion === index ? '300px' : '0',
                    overflow: 'hidden',
                    transition: 'all 0.4s ease'
                  }}
                >
                  <div style={{
                    padding: '0 28px 20px 28px'
                  }}>
                    <p style={{
                      fontSize: '13px',
                      color: '#5c636c',
                      lineHeight: '1.7',
                      margin: '0'
                    }}>
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '40px'
        }}>
          <p style={{
            fontSize: '14px',
            color: '#5c636c',
            marginBottom: '20px'
          }}>
            Could not find the question you were looking for?
          </p>
          <button style={{
            background: 'linear-gradient(135deg, #4db8cd 0%, #3da5ba 100%)',
            color: 'white',
            border: 'none',
            padding: '12px 32px',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            boxShadow: '0 6px 16px rgba(77, 184, 205, 0.25)',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 8px 20px rgba(77, 184, 205, 0.35)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 6px 16px rgba(77, 184, 205, 0.25)';
          }}
          >
            Contact Us
          </button>
        </div>
      </div>
    )
  }
}